import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'
import {initialQueryState} from '../../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../..//..//styles//styles'
import makeAnimated from 'react-select/animated'
import {locale, addLocale} from 'primereact/api'
import {Calendar} from 'primereact/calendar'
import moment from 'moment'

const EvaluationReportListFilter = () => {
  const {updateState} = useQueryRequest()
  const intl = useIntl()
  const animatedComponents = makeAnimated()

  const [properties_id, setproperties_id] = useState<string | undefined>()
  const [cost_center, setcost_center] = useState<string | undefined>()
  const [report_number, setreport_number] = useState<string | undefined>()
  const [years, setyears] = useState<Date | Date[] | undefined>(undefined)

  const API_URL = process.env.REACT_APP_API_URL || 'api'

  interface UseOption {
    readonly value: string
    readonly label: string
    readonly color: string
    readonly isFixed?: boolean
    readonly isDisabled?: boolean
  }

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})
  }

  const filterData = () => {
    updateState({
      filter: {
        properties_id,
        cost_center,
        report_number,
        years,
      },
      ...initialQueryState,
    })
  }

  const loadOptionsProperties = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProperties()
      let properties: any = []
      async function getProperties() {
        const {data} = await axios.get(`${API_URL}/sgt/v1/properties/select2`)
        let Response = data.results
        console.log('Response filter', Response)
        if (Response) {
          for (let i = 0; i < Response.length; i++) {
            const property: any = {
              value: Response[i].id,
              label: Response[i].name,
            }
            properties.push(property)
          }
        }
      }
      callback(properties)
    }, 1000)
  }

  const loadOptionsCostCenter = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getCostCenter()
      let centercosts: any = []
      async function getCostCenter() {
        const {data} = await axios.get(API_URL + '/v1/cost_centers/select2')
        let Response = data.results

        if (Response) {
          for (let i = 0; i < Response.length; i++) {
            const centercost: any = {
              value: Response[i].id,
              label: `${Response[i].name} - ${Response[i].description} `,
            }
            centercosts.push(centercost)
          }
        }
      }
      callback(centercosts)
    }, 1000)
  }

  const setConvertDate = (e: any) => {
    let DateFormate: any
    DateFormate = moment(new Date(e)).format('YYYY')
    setyears(e)
  }

  addLocale('pt', {
    firstDayOfWeek: 1,
    dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'],
    monthNames: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    monthNamesShort: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    today: 'Hoje',
    clear: 'Limpar',
  })
  locale('pt')

  return (
    <>
      <div className='card-body py-1 p-0 '>
        {/* INICIO LINHA FIXA DO FILTRO */}
        <div className='row'>
          <div className='col-lg-3'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'PROPERTIES.TITLE'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='properties_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsProperties}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'PROPERTIES.TITLE'})
                }
                onChange={(e: any) => {
                  setproperties_id(e.value)
                }}
              />
            </div>
          </div>

          <div className='col-lg-3'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'COMMON.YEAR'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <Calendar
                inputClassName='form-control form-control-solid fs-5 ps-6 fw-bold border-white'
                style={{
                  width: '100%',
                }}
                id='yearpicker'
                view='year'
                dateFormat='yy'
                onChange={(e: any) => setConvertDate(e.value)}
                value={years}
              />
            </div>
          </div>

          <div className='col-lg-3'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'COST_CENTER.TITLE'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='properties_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsCostCenter}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'COST_CENTER.TITLE'})
                }
                onChange={(e: any) => {
                  setcost_center(e.value)
                }}
              />
            </div>
          </div>

          <div className='col-lg-3'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'EVALUATION_REPORT.NUMBER'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <input
                type='text'
                className='form-control form-control-solid '
                size={100}
                onChange={(e) => {
                  setreport_number(e.target.value)
                }}
              />
            </div>
          </div>
        </div>
        {/* FIM LINHA FIXA DO FILTRO */}

        {/* INICIO FILTRO RETRATIL FIXA DO FILTRO */}
      </div>
    </>
  )
}

export {EvaluationReportListFilter}
